<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            Datos del indicador
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body">
            <q-form ref="form">
              <div class="row">
                <!--IdProveedor-->
                <div class="col-2">
                  <div class="divLabel">ID Proveedor</div>
                  <div class="divTexto">{{idProveedor}}</div>
                </div>
                <!--Nombre indicador-->
                <div class="col-10">
                  <div class="divLabel">Nombre del indicador</div>
                  <div class="divTexto">{{name}}</div>
                </div>
              </div>
              <div class="row">
                <!--periodicidad-->
                <div class="col-2">
                  <div class="divLabel">Periodicidad</div>
                  <div class="divTexto">{{periodicidad}}</div>
                </div>
                <!--unidad de medidad-->
                <div class="col-3">
                  <div class="divLabel">Unidad de medida</div>
                  <div class="divTexto">{{unidadMedida}}</div>
                </div>
                <!--valor recomendado-->
                <div class="col-3">
                  <div class="divLabel">{{labelRecomendado}}</div>
                  <div class="divTexto">{{valorRecomendado}}</div>
                </div>
                <!--entidad recomendadora-->
                <div class="col-4">
                  <div class="divLabel">Entidad Recomendadora</div>
                  <div class="divTexto">{{recomendadoPor}}</div>
                </div>
              </div>
              <div class="row">
                <!--fuente-->
                <div class="col-8">
                  <div class="divLabel">Fuente</div>
                  <div class="divTexto">{{fuente}}</div>
                </div>
                <!--como se calcula-->
                <div class="col-4">
                  <div class="divLabel">Cómo se calcula</div>
                  <div class="divTexto">{{formula}}</div>
                </div>
              </div>
              <div class="row">
                <!--que es-->
                <div>
                  <div class="divLabel">Qué es</div>
                  <div class="divTexto">{{descripcion}}</div>
                </div>
              </div>
              <div class="row">
                <!--beneficio-->
                <div>
                  <div class="divLabel">Beneficio</div>
                  <div class="divTexto">{{beneficio}}</div>
                </div>
              </div>
              <div class="row">
                <!--aclaraciones-->
                <div class="col-12">
                  <q-input
                  v-model="aclaraciones"
                  type="textarea"
                  label="Aclaraciones"
                  outlined
                ></q-input>
                </div>
              </div>
              <div class="row select">
                <!--ods-->
                <div class="col-1">
                  <q-img
                    class="Imagen"
                    :src="imgODSSelected"
                    :name="imgODSSelected"
                    style="border-radius: 0px !important"
                    width="50px"
                    height="50px"
                  />
                </div>
                <q-select
                  class="input col-11"
                  outlined
                  :options="arrayObjetivosODS"
                  option-value="id"
                  option-label="name"
                  v-model="objetivoODSSelected"
                />
              </div>
              <div class="row select">
                <!--estrategicos-->
                <div class="col-1">
                  <q-img
                    class="Imagen"
                    :src="imgEstrategicoSelected"
                    :name="imgEstrategicoSelected"
                    style="border-radius: 50%"
                    width="50px"
                    height="50px"
                  />
                </div>
                <q-select
                  class="input col-11"
                  outlined
                  :options="arrayObjetivosEstrategicos"
                  option-value="id"
                  option-label="name"
                  v-model="objetivoEstrategicoSelected"
                  :error="$v.objetivoEstrategicoSelected.$error"
                  :rules="[ val => (val.name !== 'Seleccione un objetivo estratégico') || 'Debe seleccionar un objetivo']"
                />
              </div>
              <div class="row select">
                <!--especificos-->
                <div class="col-1">
                </div>
                <q-select
                  class="input col-11"
                  outlined
                  :options="arrayObjetivosEspecificos"
                  option-value="id"
                  option-label="name"
                  v-model="objetivoEspecificoSelected"
                  :error="$v.objetivoEspecificoSelected.$error"
                  :rules="[ val => (val.name !== 'Seleccione un objetivo específico') || 'Debe seleccionar un objetivo']"
                />
              </div>
            </q-form>
          </slot>
        </q-card-section>

        <q-card-actions align="right" class="text-primary container-actions">
          <q-btn
            class="bSecondary"
            flat
            label="Cancelar"
            v-close-popup
            @click="cancel()"
          />
          <q-btn
            label="Guardar"
            class="bPrincipal"
            padding="xs lg"
            @click="save()"
            :disable="objetivoEspecificoSelected.id === undefined || objetivoEstrategicoSelected.id === undefined ? true : false"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog, QForm, QImg } from 'quasar';
import Validation from '@/components/shared/mixins/Validation.js';
import { required } from 'vuelidate/lib/validators';
import Resources from '@/components/shared/mixins/Resources.js';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';

export default {
  mixins: [Validation, Resources, Loading],
  components: {
    QDialog,
    QForm,
    QImg
  },
  validations: {
    objetivoEspecificoSelected: { required },
    objetivoEstrategicoSelected: { required }
  },
  props: {
    value: {
      required: true
    },
    datosIndicador: {
      required: true
    }
  },
  data () {
    return {
      valueLocal: this.value,
      arrayObjetivosEstrategicos: [],
      objetivoEstrategicoSelected: {},
      imgEstrategicoSelected: '',
      arrayObjetivosODS: [],
      objetivoODSSelected: {},
      imgODSSelected: '',
      arrayObjetivosEspecificos: [],
      objetivoEspecificoSelected: {},
      idProveedor: '',
      name: '',
      periodicidad: '',
      unidadMedida: '',
      valorRecomendado: '',
      recomendadoPor: '',
      fuente: '',
      formula: '',
      descripcion: '',
      benefincio: '',
      aclaraciones: '',
      labelRecomendado: 'Valor recomendado'
    };
  },
  created () {
    this.fillDetalle();
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    },
    objetivoEstrategicoSelected: {
      handler: function (val) {
        this.loading = true;
        if (!val) return;
        this.imgEstrategicoSelected = this.getImg(val.file);
        if (val.id !== null && val.id !== undefined) {
          this.fillSelectorObjetivosEspecificos();
        } else {
          this.arrayObjetivosEspecificos = [];
          this.arrayObjetivosEspecificos.push({ name: 'Seleccione un objetivo específico' });
          this.objetivoEspecificoSelected = this.arrayObjetivosEspecificos[0];
        }
      },
      deep: true
    },
    objetivoODSSelected: {
      handler: function (val) {
        this.loading = true;
        if (!val) return;
        this.imgODSSelected = this.getImg(val.file);
      },
      deep: true
    }
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    save () {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.objetivoEspecificoSelected.id !== undefined && this.objetivoEstrategicoSelected.id !== undefined) {
            this.newDato = {
              idIndicador: this.datosIndicador.id,
              aclaraciones: this.aclaraciones,
              idODS: this.objetivoODSSelected.id !== undefined ? this.objetivoODSSelected.id : null,
              idObjetivoEstrategico: this.objetivoEstrategicoSelected.id,
              idObjetivoEspecifico: this.objetivoEspecificoSelected.id

            };
            this.$emit('input', false);
            this.$emit('saveDetalleIndicador', this.newDato);
          }
        }
      });
    },
    fillDetalle () {
      this.idProveedor = this.datosIndicador.idProveedor;
      this.name = this.datosIndicador.name;
      this.periodicidad = this.datosIndicador.periodicidad;
      this.unidadMedida = this.datosIndicador.unidadMedida;
      this.valorRecomendado = this.datosIndicador.minimoRecomendado !== undefined ? this.datosIndicador.minimoRecomendado : this.datosIndicador.maximoRecomendado;
      this.labelRecomendado = this.datosIndicador.minimoRecomendado !== undefined ? 'Mínimo Recomendado' : 'Máximo Recomendado';
      this.recomendadoPor = this.datosIndicador.recomendadoPor;
      this.fuente = this.datosIndicador.fuente;
      this.formula = this.datosIndicador.formula;
      this.descripcion = this.datosIndicador.descripcion;
      this.beneficio = this.datosIndicador.beneficio;
      this.aclaraciones = this.datosIndicador.aclaraciones;
      this.fillSelectorObjetivosEstategicos();
      this.fillSelectorObjetivosODS();
    },
    async fillSelectorObjetivosEstategicos () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_ALL_AUEOBJETIVES).then(response => {
        this.arrayObjetivosEstrategicos = [];
        this.arrayObjetivosEstrategicos.push({ name: 'Seleccione un objetivo estratégico', file: [{ fileKey: 'imagen', url: require(`@/assets/img/AUE.svg`) }] });
        let count = 0;
        response.data.forEach(objetivo => {
          let objetivoFormated = objetivo.prefix + ': ' + objetivo.name;
          this.arrayObjetivosEstrategicos.push({ name: objetivoFormated, file: objetivo.file, id: objetivo.id });
          if ((this.datosIndicador.objetivoEstrategico !== null && this.datosIndicador.objetivoEstrategico !== undefined) && this.datosIndicador.objetivoEstrategico.id === objetivo.id) {
            count++;
            this.objetivoEstrategicoSelected = { name: objetivoFormated, file: objetivo.file, id: objetivo.id };
          }
        });
        if (count === 0) {
          this.objetivoEstrategicoSelected = this.arrayObjetivosEstrategicos[0];
        }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    async fillSelectorObjetivosODS () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_ALL_ODSOBJETIVOS).then(response => {
        this.arrayObjetivosODS = [];
        this.arrayObjetivosODS.push({ name: 'Seleccione un objetivo de desarrollo sostenible', file: [{ fileKey: 'imagen', url: require(`@/assets/img/ods-logo-rueda.png`) }] });
        let count = 0;
        response.data.forEach(objetivo => {
          this.arrayObjetivosODS.push({ name: objetivo.name, file: objetivo.file, id: objetivo.id });
          if (this.datosIndicador.objetivoODS.id === objetivo.id) {
            count++;
            this.objetivoODSSelected = { name: objetivo.name, file: objetivo.file, id: objetivo.id };
          }
        });
        if (count === 0) {
          this.objetivoODSSelected = this.arrayObjetivosODS[0];
        }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    async fillSelectorObjetivosEspecificos () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_OBJETIVOS_ESPECIFICOS, { idObjetivo: this.objetivoEstrategicoSelected.id }).then(response => {
        this.arrayObjetivosEspecificos = [];
        this.arrayObjetivosEspecificos.push({ name: 'Seleccione un objetivo específico' });
        let count = 0;
        response.data.forEach(objetivo => {
          this.arrayObjetivosEspecificos.push(objetivo);
          if (this.datosIndicador.objetivoEspecifico.id === objetivo.id) {
            count++;
            this.objetivoEspecificoSelected = objetivo;
          }
        });
        if (count === 0) {
          this.objetivoEspecificoSelected = this.arrayObjetivosEspecificos[0];
        }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    getImg (fileArray) {
      let res = this.searchResource(fileArray, 'imagen');
      return res ? res.url : this.getDefaultResource('imagen');
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  min-width: 1200px;
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.29;
      color:#474848;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  .container-auth {
    .title-option {
      font-family: DINPro;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5c5c5c;
      padding-bottom: 20px;
    }
  }
  &::v-deep {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
  }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}

  .row {
    div{
      padding: 4px;
    }
  }
  .divLabel {
    font-family: DINPro;
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.27px;
    color: #002f6c;
    margin-bottom:5px;
  }
  .Imagen{
    float: left;
    margin-right: 12px;
    background-color: white;
  }

  .input {
    background-color: #fff;
    border-radius: 10px;
  }
  .select {
    padding-top: 15px;
  }
  .select:last-of-type {
    padding-top: 0px;
  }

</style>
